module.exports = __webpack_public_path__ + "img/brands-wasa-recipes.png?d54674afa0358c92fa47c0e7803e82a8";